/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export function selectMode (state) {
    return state.form.mode;
}

export function selectAllCollasped (state) {
    return state.form.allCollapsed;
}

export function selectReorderActive (state) {
    return state.form.reorderActive;
}

export function selectLoadingForm (state) {
    return state.form.loadingForm;
}

export function selectForSettingsIsDirty (state) {
    return state.form.settings.isDirty;
}

export function selectForSettingsIsSubmitting (state) {
    return state.form.settings.isSubmitting;
}


/**
 * @param {RootState} state
 * @param {string} group
 */
export function selectContentOnly (state, group) {

    // Use the nullish coalescing operator (??) to default this value
    // as on initial read for any group, it will be undefined.
    // Using a logical or here (||) would cause this variable to always be true
    // which is undesirable.
    const enabled = state.form.contentOnly[group] ?? false;
    return enabled;
}

/**
 * @param {RootState} state
 */
export function selectModal (state) {
    return state.form.modal;
}

/**
 * @param {RootState} state
 */
export function selectLastQuestionAdded (state) {
    return state.form.lastQuestionAdded;
}

/**
 * @param {RootState} state
 */
export function selectCombineAllSteps (state) {
    return state.form.combineAllSteps;
}

/**
 * @param {RootState} state
 */
export function selectIgnoreFieldValidation (state) {
    return state.form.ignoreFieldValidation;
}

/**
 * @typedef {import("./form.state")["formState"]} FormState
 */

/**
 * @typedef {object} RootState
 * @property {FormState} form
 */
